/* LUXORA motion layer: scroll progress, header depth, hero parallax (desktop only), count-up. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Phones / tablets (and in-app browsers like Instagram) skip the parallax: it forces layout on every scroll frame. */
  var lowPower = window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
  var bar = document.createElement('div');
  bar.className = 'm-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  var header = document.querySelector('[data-header]');
  var layers = [];
  var ticking = false;
  var countObserver = null;

  function collectLayers(scope) {
    if (reduce || lowPower) return;
    (scope || document).querySelectorAll('main img').forEach(function (img) {
      if (img.hasAttribute('data-m-par')) return;
      var parent = img.parentElement;
      if (!parent) return;
      var cs = window.getComputedStyle(img);
      var ps = window.getComputedStyle(parent);
      if (cs.position !== 'absolute' || ps.overflow !== 'hidden') return;
      if (parent.offsetHeight < 300) return;
      img.setAttribute('data-m-par', '');
      img.style.scale = '1.1';
      layers.push({ img: img, parent: parent });
    });
  }

  function update() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var vh = window.innerHeight;
    var max = document.documentElement.scrollHeight - vh;
    bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0).toFixed(4) + ')';

    if (header) {
      if (y > 24) header.setAttribute('data-scrolled', '');
      else header.removeAttribute('data-scrolled');
    }

    for (var i = 0; i < layers.length; i++) {
      var L = layers[i];
      if (!document.body.contains(L.img)) continue;
      var r = L.parent.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      p = Math.max(-1, Math.min(1, p));
      L.img.style.translate = '0 ' + (-p * r.height * 0.04).toFixed(1) + 'px';
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function countUp(el) {
    var end = parseInt(el.textContent, 10);
    if (isNaN(end) || end < 2 || reduce) return;
    var start = null;
    var duration = 1200;
    el.textContent = '0';
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = String(Math.round(end * eased));
      if (t < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  function observeCounts(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (!countObserver) {
      countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            countObserver.unobserve(entry.target);
            countUp(entry.target);
          }
        });
      }, { threshold: 0.4 });
    }
    (scope || document).querySelectorAll('[data-days]').forEach(function (el) {
      if (el.hasAttribute('data-m-count')) return;
      el.setAttribute('data-m-count', '');
      countObserver.observe(el);
    });
  }

  function init(scope) {
    collectLayers(scope);
    observeCounts(scope);
    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('load', function () { collectLayers(document); requestUpdate(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  init(document);
})();
